import a from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import v from "./iconfont.es5471.js";
const r = {
  display: "block"
}, g = ({ size: e = 16, useVw: l, useRem: n, color: o, withColor: c, removeClassName: t, disableSSR: h, style: d, ...m }) => {
  const p = d ? { ...r, ...d } : r;
  return /* @__PURE__ */ a.createElement(v, { disableSSR: h }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-tongyizhanghu", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (n ? "rem" : "px"), height: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (n ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: p, fill: "none", ...m }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-ç»ä¸è´¦æ·"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: c ? i(o, 0, "#262933") : "#262933",
        datafollowfill: c ? i(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M3.1 9.109A3.789 3.789 0 0 1 6.89 5.32h18.222a3.789 3.789 0 0 1 3.79 3.789v6.389a.9.9 0 1 1-1.8 0V9.109a1.99 1.99 0 0 0-1.99-1.989H6.89A1.99 1.99 0 0 0 4.9 9.11v13.778c0 1.098.89 1.989 1.989 1.989h11.118a.9.9 0 0 1 0 1.8H6.889a3.789 3.789 0 0 1-3.789-3.79V9.11Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M11.489 10.357a2.611 2.611 0 1 0 0 5.222 2.611 2.611 0 0 0 0-5.222Zm-.811 2.611a.811.811 0 1 1 1.622 0 .811.811 0 0 1-1.622 0Zm-.9 3.221A2.678 2.678 0 0 0 7.1 18.867v.888c0 .988.801 1.79 1.789 1.79h5.333a1.79 1.79 0 0 0 1.79-1.79v-.888a2.678 2.678 0 0 0-2.678-2.678H9.777ZM8.9 18.867c0-.485.393-.878.878-.878h3.556c.484 0 .877.393.877.878v.877h-5.31v-.877Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M17.322 12.442a.9.9 0 0 1 .9-.9h5.334a.9.9 0 0 1 0 1.8h-5.334a.9.9 0 0 1-.9-.9ZM20 15.098a.9.9 0 1 0 0 1.8h3.556a.9.9 0 0 0 0-1.8H20Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M21.975 24.695a2.086 2.086 0 0 1 0-2.95l1.675-1.675a2.086 2.086 0 0 1 2.95 0l1.675 1.675a2.086 2.086 0 0 1 0 2.95L26.6 26.37a2.086 2.086 0 0 1-2.95 0l-1.675-1.675Zm1.273-1.677 1.674-1.675a.286.286 0 0 1 .405 0l1.675 1.675a.286.286 0 0 1 0 .404l-1.675 1.675a.286.286 0 0 1-.405 0l-1.674-1.675a.286.286 0 0 1 0-.404Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, Z = g;
export {
  Z as default
};
